(function(){
  function init(root){
    if(!root||root.dataset.aysReady==='true')return;
    root.dataset.aysReady='true';

    var main=root.querySelector('.aym-main-image');
    var thumbs=[].slice.call(root.querySelectorAll('.aym-thumb'));
    var current=Math.max(0,thumbs.findIndex(function(thumb){return thumb.classList.contains('is-active')}));
    function activate(index,scrollThumb){
      if(!main||!thumbs.length)return;
      current=(index+thumbs.length)%thumbs.length;
      thumbs.forEach(function(thumb,i){
        thumb.classList.toggle('is-active',i===current);
        if(i===current)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');
      });
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src=thumbs[current].dataset.src;
      main.alt=thumbs[current].dataset.alt||'Strawberry product image';
      if(scrollThumb&&thumbs[current].scrollIntoView)thumbs[current].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }
    thumbs.forEach(function(thumb,index){thumb.addEventListener('click',function(event){event.preventDefault();activate(index,true)})});
    function move(delta){activate(current+delta,true)}
    [root.querySelector('.ays-gallery-prev'),root.querySelector('.aym-gallery-arrow--prev')].forEach(function(button){if(button)button.addEventListener('click',function(event){event.preventDefault();move(-1)})});
    [root.querySelector('.ays-gallery-next'),root.querySelector('.aym-gallery-arrow--next')].forEach(function(button){if(button)button.addEventListener('click',function(event){event.preventDefault();move(1)})});
    var frame=root.querySelector('.aym-gallery-main');
    if(frame)frame.addEventListener('keydown',function(event){if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}if(event.key==='ArrowRight'){event.preventDefault();move(1)}});

    var lightbox=document.getElementById(root.dataset.lightboxId||'');
    var zoom=root.querySelector('.aym-zoom');
    function openLightbox(){if(!lightbox||!main)return;var image=lightbox.querySelector('img');image.src=main.src;image.alt=main.alt;lightbox.classList.add('is-open');lightbox.setAttribute('aria-hidden','false')}
    function closeLightbox(){if(!lightbox)return;lightbox.classList.remove('is-open');lightbox.setAttribute('aria-hidden','true')}
    if(zoom)zoom.addEventListener('click',openLightbox);
    if(lightbox){
      var close=lightbox.querySelector('.aym-lightbox__close');
      if(close)close.addEventListener('click',closeLightbox);
      lightbox.addEventListener('click',function(event){if(event.target===lightbox)closeLightbox()});
    }
    document.addEventListener('keydown',function(event){if(event.key==='Escape')closeLightbox()});

    var sellingPlan=root.querySelector('.aym-selling-plan-input');
    var planSelect=root.querySelector('[data-ays-plan-select]');
    var subDetail=root.querySelector('[data-ays-sub-detail]');
    [].slice.call(root.querySelectorAll('.aym-purchase-card input')).forEach(function(input){
      input.addEventListener('change',function(){
        [].slice.call(root.querySelectorAll('.aym-purchase-card')).forEach(function(card){card.classList.toggle('is-selected',card.contains(input)&&input.checked)});
        var isSubscription=input.value==='subscription';
        if(sellingPlan){sellingPlan.disabled=!isSubscription;if(isSubscription&&planSelect)sellingPlan.value=planSelect.value}
        if(subDetail){subDetail.classList.toggle('is-visible',isSubscription);subDetail.hidden=!isSubscription}
      });
    });
    if(planSelect)planSelect.addEventListener('change',function(){if(sellingPlan&&!sellingPlan.disabled)sellingPlan.value=planSelect.value});

    var qty=root.querySelector('.aym-quantity input');
    var minus=root.querySelector('[data-qty-minus]');
    var plus=root.querySelector('[data-qty-plus]');
    if(minus&&qty)minus.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});
    if(plus&&qty)plus.addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1});

    var form=document.getElementById(root.dataset.formId||'');
    var mobileAdd=root.querySelector('[data-mobile-add]');
    if(form&&mobileAdd)mobileAdd.addEventListener('click',function(){form.requestSubmit?form.requestSubmit():form.submit()});

    [].slice.call(root.querySelectorAll('.aym-tab')).forEach(function(tab){
      tab.addEventListener('click',function(){
        var name=tab.dataset.tab;
        [].slice.call(root.querySelectorAll('.aym-tab')).forEach(function(item){item.classList.toggle('is-active',item===tab)});
        [].slice.call(root.querySelectorAll('.aym-tab-panel')).forEach(function(panel){panel.classList.toggle('is-active',panel.dataset.panel===name)});
      });
    });

    var faqs=[].slice.call(root.querySelectorAll('.aym-faq-panel details'));
    faqs.forEach(function(item){item.addEventListener('toggle',function(){if(item.open)faqs.forEach(function(other){if(other!==item)other.open=false})})});

    function positionSticky(){
      var bar=root.querySelector('.aym-mobile-bar');
      if(!bar)return;
      var preview=document.querySelector('#preview-bar-iframe,iframe[src*="preview_bar"],.shopify-preview-bar');
      var offset=preview&&preview.getBoundingClientRect?Math.ceil(preview.getBoundingClientRect().height||0):0;
      if(!offset&&/preview_theme_id|_fd=0|pb=0/.test(location.search))offset=92;
      bar.style.bottom='calc('+(offset+10)+'px + env(safe-area-inset-bottom))';
    }
    positionSticky();
    addEventListener('resize',positionSticky);
    setTimeout(positionSticky,900);
  }
  function boot(scope){
    var roots=[];
    if(scope&&scope.matches&&scope.matches('.ays-pdp[data-ays-strawberry]'))roots.push(scope);
    if(scope&&scope.querySelectorAll)roots=roots.concat([].slice.call(scope.querySelectorAll('.ays-pdp[data-ays-strawberry]')));
    roots.forEach(init);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target)});
})();
